<script>
    import Spinner from "../../components/spinner/Spinner.svelte";
    import FormErrors from "../../components/forms/FormErrors.svelte";
    import {apiPost} from '../../apiFetch';
    import {createForm} from "svelte-forms-lib";
    import {
        Button,
        Form,
        FormGroup,
        Input,
        Label,
    } from 'sveltestrap';
    import {_} from 'svelte-i18n';
    import {url} from "@sveltech/routify";

    let submitting = false;
    let completed = false;
    let formError = null;

    export let email = null;

    const {form, handleChange, handleSubmit} = createForm({
        initialValues: {
            email: email,
        },
        onSubmit: values => {
            submitting = true;
            apiPost('API_RESET_PASSWORD_URL', values)
                    .then((result) => {
                        if (result.status !== 200) {
                            formError = result.errors;
                        } else {
                            completed = true;
                        }
                        submitting = false;
                    })
                    .catch((error) => {
                        alert(error);
                        submitting = false;
                    });
        }
    });

</script>

{#if submitting}
    <Spinner/>
{/if}
{#if formError}
    <FormErrors errors={formError}/>
{/if}
<div class="container">
    {#if completed}
        <div class="alert alert-info">
            <p>{$_('page.password.messageComplete')}</p>
        </div>
        <div>
            <a href={$url('/login')} class="btn btn-primary">{$_('page.password.backToLogin')}</a>
        </div>

    {:else}
        <Form on:submit={handleSubmit} class="content">
            <FormGroup>
                <Label for="email">{$_('global.email')}</Label>
                <Input
                        id="email"
                        name="email"
                        type="email"
                        placeholder={$_('global.email')}
                        on:change={handleChange}
                        bind:value={$form.email}
                />
            </FormGroup>

            <FormGroup>
                <Button type="submit" color="primary">{$_('page.password.resetPassword')}</Button>
            </FormGroup>
        </Form>

        <p><small>{$_('page.password.supportMessage')}</small></p>
    {/if}
</div>